import {
  APIProvider,
  InfoWindow,
  Map,
  Marker,
} from "@vis.gl/react-google-maps";
import { Button } from "antd";
import LabeledInput from "components/Form/LabeledInput";
import { GOOGLE_API_KEY } from "constants/common";
import useCreatePlace from "hooks/useCreatePlace";
import { MdPlace } from "react-icons/md";
import dropOff from "assets/images/drop-off.png";
import PlaceInfo from "./components/PlaceInfo";

export default function CreatePlace() {
  const {
    control,
    places,
    viewPlace,
    loading,
    currentLocation,
    selectedLocation,
    zoomLevel,
    handleZoomChanged,
    handleSubmit,
    handleShowPlace,
    onSubmit,
    handleClosePlace,
    handleLocationSelected,
  } = useCreatePlace();

  return (
    <div
      className="w-full bg-white rounded-lg p-6 flex"
      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
    >
      <div className="w-1/3 pt-5 pb-5">
        <div className="w-full">
          <h1 className="p-5 font-light text-lg text-center">Add New Place</h1>
          <div className="w-full">
            <div className="w-full relative h-1 top-7 overflow-clip rounded-md">
              <div className="w-1/2 bg-black h-full rounded-md"></div>
            </div>
            <div className="relative w-full flex justify-center">
              <div className="relative h-14 w-14 bg-black rounded-full flex items-center justify-center text-white text-2xl">
                <MdPlace />
              </div>
            </div>
          </div>
          <p className="text-center mt-2 text-sm font-normal">
            Place Information
          </p>
        </div>
        <div className="w-full py-8 px-5">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="w-full flex flex-col"
          >
            <div className="w-full px-4 pt-5">
              <LabeledInput
                label="Name"
                type="text"
                control={control}
                name="name"
                placeholder="Name"
              />
            </div>
            <div className="w-full px-4 pt-5">
              <div className="w-full">Select Location from Map</div>
            </div>
            <div className="w-full px-4 pt-5 flex items-center gap-x-2">
              <LabeledInput
                label="Latitude"
                type="text"
                control={control}
                name="latitude"
                placeholder="Latitude"
              />
            </div>
            <div className="w-full px-4 pt-5 flex items-center gap-x-2">
              <LabeledInput
                label="Longitude"
                type="text"
                control={control}
                // disabled
                name="longitude"
                placeholder="Longitude"
              />
            </div>
            <div className="w-full flex mt-8 justify-end">
              <Button
                loading={loading}
                htmlType="submit"
                type="primary"
                className="py-2 px-8 rounded-md float-right h-auto font-medium w-fit shadow-none"
              >
                Add Place
              </Button>
            </div>
          </form>
        </div>
      </div>
      <div className="grow">
        <APIProvider apiKey={GOOGLE_API_KEY}>
          <Map
            defaultZoom={14}
            defaultCenter={currentLocation}
            onClick={handleLocationSelected}
            onZoomChanged={handleZoomChanged}
          >
            {selectedLocation && <Marker position={selectedLocation}></Marker>}
            {places.map((place) => (
              <Marker
                key={place.id}
                position={{ lat: place.latitude, lng: place.longitude }}
                onClick={() => handleShowPlace(place)}
                icon={{
                  url: dropOff,
                  size: new google.maps.Size(36, 30),
                  origin: new google.maps.Point(0, 0),
                  anchor: new google.maps.Point(18, 40),
                  scaledSize: new google.maps.Size(36, 30),
                  rotation: 1,
                }}
                optimized
              />
            ))}
            {viewPlace?.id && (
              <InfoWindow
                key={`${viewPlace.id}`}
                position={{
                  lat: viewPlace.latitude + zoomLevel,
                  lng: viewPlace.longitude,
                }}
                headerDisabled
                onCloseClick={handleClosePlace}
              >
                <PlaceInfo place={viewPlace} />
              </InfoWindow>
            )}
          </Map>
        </APIProvider>
      </div>
    </div>
  );
}
